import { generateAPI } from "../api.generator";
import { SupportTicket } from "../../types/ticket";

// GET /support-ticket/mine/:id — one of the customer's own tickets.
// Pass the ticket id via `params`.
export const getMyTicket = generateAPI<{ params: string }, SupportTicket>(
  "get",
  "support-ticket/mine"
);
